import { CustomNextImage as Image } from '@crehana/next';

import { ItemContainer } from './PacksCarousel.styles';
import type { ItemProps } from './types';

const CarouselItem: React.FC<React.PropsWithChildren<ItemProps>> = ({
  imagePlaceholder,
  professorName,
  promoImage,
  title,
  isSelected,
  handleClick,
}) => (
  <ItemContainer
    onClick={handleClick}
    isSelected={isSelected}
    className="flex flex-col overflow-hidden flex-shrink-0 "
  >
    {/* This syntax requires an imported helper but module 'tslib' cannot be found. */}
    {/* eslint-disable-next-line jsx-a11y/alt-text */}
    <Image
      src={promoImage}
      height={160}
      width={260}
      objectFit="cover"
      loading="lazy"
      placeholder="blur"
      blurDataURL={imagePlaceholder}
    />
    <div
      className="bg-white p-24 flex flex-col justify-between"
      css={`
        height: 45%;
      `}
    >
      <p className="font-subtitle3 text-base-dark ">{title}</p>
      <p className="font-body4 text-base-dark">Por {professorName}</p>
    </div>
  </ItemContainer>
);

export default CarouselItem;
